module.exports = __webpack_public_path__ + "img/invest-dis.1589a646.png";